import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router";

import { AuthContext } from "../../contexts/auth_provider";

const SpinnerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "fixed",
    width: "100%",
    height: "95vh",
    flexDirection: "column",
};

export default function ProtectedRoute() {
    const { user, isLoading } = useContext(AuthContext);
    const location = useLocation();

    if (isLoading) {
        return (
            <div style={SpinnerStyle}>
                <img
                    src="/MyCorvus.png"
                    alt="none"
                    width="300"
                    style={{ display: "block" }}
                />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
}
